export default {
  loading: 'Loading...',
  // header
  aboutus: 'About Us',
  vision_and_mission: 'Vision and Mission',
  why_sistesi: 'Why Sistesi',
  product: 'Product',
  // footer
  about_exi: 'About Exi Global Aplikasi',
  followus: 'Follow us',
  contact_us: 'Contact Us',
  others: 'Others',
  privacy_policy: 'Privacy Policy',
  term_and_condition: 'Term and Condition',
  error: {
    title: 'Whoops, 404',
    text: 'The page you were looking for does not exist',
    text_btn: 'Return to the main page',
  },
  home: {
    company_profile: 'is a school management software that is able to record student history (biodata, grades, counseling, extracurricular, financial / SPP, book loans, attendance, etc.) from students entering to graduate or leaving the school. Besides that, the SYSTEM is equipped with an Online / Paperless Examination System. We also integrate systems with RFID technology in the form of a Multifunctional Smart Card.',
    company_profile_download: 'Download SISTesi',
    vision: {
      text_title: 'Our Vision and Mission',
      text_detail: 'Making SISTESI a total solution that continues to innovate to overcome the problems and challenges faced by educational institutions in the present and in the future.',
      text_a: 'Apply systemic solutions as operational management platforms, information systems and centers of economic activity in national education institutions.',
      text_b: 'Conduct regular training for all school human resources for the application of system solutions and other educational programs.',
      text_c: 'Conduct research and development on software and hardware technology to continue to innovate.',
      text_d: 'Absorbing the aspirations of the students, the community and students for the development of SISTESI services in line with the times and technology.',
      text_e: 'Collaborating with third parties to collaborate in adding service features that are efficient and useful for all SISTESI stakeholders.',
    },
    value: {
      title: 'Why SISTesi',
      text_a: 'Dashboard Monitoring',
      text_b: 'Security',
      text_c: 'Integrated',
    },
    product: {
      title: 'SISTesi Product',
      tagline: '* per month per child',
      btn_plan: 'VIEW PLAN',
      text_lite_1: 'School & Teacher Admin (SIM) Features',
      text_lite_2: 'Features of Parents / Trustee / Students / i',
      text_lite_3: 'Prices are valid for all of Indonesia',
      text_basic_1: 'School & Teacher Admin (SIM) Features',
      text_basic_2: 'Features of Parents / Trustee / Students / i',
      text_basic_3: 'Free Hardware & Free Student ID Card / i',
      text_basic_4: 'For students who register first',
      text_basic_5: 'Price only for java & bali',
      text_basic_6: 'Prices outside of Java & Bali is IDR 23.000 include VAT',
      text_subscribe_1: 'School & Teacher Admin (SIM) Features',
      text_subscribe_2: 'Features of Parents / Trustee / Students / i',
      text_subscribe_3: 'For parents / Trustee / students who subscribe for IDR 15,000',
      text_price_for_java: '* Prices include VAT',
      text_free: 'Free e-Learning and e-Test',
      text_phone: 'For further promotions, please contact our marketing at',
      footer: 'Prices outside Java and Bali are subject to an additional fee of IDR 6,000 before 10% VAT',
    },
  },
  contact: {
    title: 'Contact Us',
    tagline: 'Suggestions, comments or questions related to our products or services can be addressed to us via telephone number +62 21 766-9525 or e-mail to info@sistesi.id.',
  },
};
